import type { FieldInstanceFields } from "@regrello/graphql-api";

import { getFieldInstanceId } from "./getFieldInstanceId";

/**
 * Returns the form field ID of the provided field instance, assuming it belongs to a form.
 *
 * @throws if the field instance does not have a form field ID.
 */
export function getFieldInstanceFormFieldIdOrThrow(
  fieldInstance: Pick<FieldInstanceFields, "formFieldID" | "values">,
): number {
  if (fieldInstance.formFieldID == null) {
    throw new Error(`Field instance's form field ID is unexpectedly null: ${getFieldInstanceId(fieldInstance)}`);
  }
  return fieldInstance.formFieldID;
}
